import { render } from "./Interaction.vue?vue&type=template&id=dc514986&scoped=true"
import script from "./Interaction.vue?vue&type=script&lang=js"
export * from "./Interaction.vue?vue&type=script&lang=js"

import "./Interaction.vue?vue&type=style&index=0&id=dc514986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc514986"]])

export default __exports__